export enum UserTypeEnum {
  customer = 'Customer',
  appServiceUser = 'AppServiceUser',
  generalUser = 'GeneralUser',
  vendor = 'Vendor',
  student = 'Student',
  user = 'User',
  teacher = 'Teacher',
}
